import { render, staticRenderFns } from "./leggiBarcode.vue?vue&type=template&id=2bcb5552&scoped=true&"
import script from "./leggiBarcode.vue?vue&type=script&lang=js&"
export * from "./leggiBarcode.vue?vue&type=script&lang=js&"
import style0 from "./leggiBarcode.vue?vue&type=style&index=0&id=2bcb5552&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcb5552",
  null
  
)

export default component.exports